module.exports = __webpack_public_path__ + "img/help-levy-mill-rate-fr.png";